import { styled, Tooltip, Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary } from "@mui/material";
import { ArrowForwardIosSharp } from "@mui/icons-material";
import { isMobile } from 'react-device-detect';

const StyledAccordion = styled(({ expanded, isPortrait = false, ...props }) => (
    <MuiAccordion
        disableGutters
        square
        elevation={0}
        expanded={expanded}
        slotProps={{ transition: { unmountOnExit: true } }} // improves performance (see https://mui.com/material-ui/react-accordion/#performance)
        {...props}
    />
))(({ theme, expanded, isPortrait }) => ({
    borderTop: `1px solid ${theme.palette.divider}`,
    borderLeft: isMobile && !isPortrait && `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0
    },
    '&:last-child': {
        borderBottom: expanded && !isMobile && 0
    },
    '&::before': {
        display: 'none'
    }
}))

// span wrapper is required because MUI disables pointer-events on disabled controls
export const Accordion = ({ disabledTooltip, ...props }) => {
    const accordion = <StyledAccordion {...props} />
    if (props.disabled && disabledTooltip) {
        return (
            <Tooltip title={disabledTooltip} placement="top" arrow>
                <span style={{ display: 'block' }}>{accordion}</span>
            </Tooltip>
        )
    }
    return accordion
}
  
export const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#F7F7F7',
    flexDirection: 'row-reverse',
    minHeight: isMobile ? 48 : 58,
    '&.Mui-expanded': {
        minHeight: isMobile ? 48 : 58
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)'
    },
    '& .MuiAccordionSummary-content': {
        ...theme.typography.h6,
        marginLeft: theme.spacing(1.5),
        marginTop: 0,
        marginBottom: 0,
        textTransform: 'uppercase',
        fontSize: { xs: '1rem', sm: '1.25rem' },
        fontWeight: undefined
    },
    '&.Mui-expanded .MuiAccordionSummary-content': {
        marginTop: 0,
        marginBottom: 0
    },
    '&.accordion-with-subtitle .MuiAccordionSummary-content': {
        overflow: 'hidden'
    },
    '& .accordion-subtitle': {
        fontSize: isMobile ? '0.65rem' : '0.75rem',
        opacity: 0.8,
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
}))
  
export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`
}))